import { getMethod, postMethod, putMethod, deleteMethod } from "../../api-service/api-service";
import {
    setProducts,
    setSelectedProduct,
    addProduct,
    updateProduct,
    removeProduct,
    setLoading
} from "./productSlice";

export const fetchProductsAction = (params = {}) => async (dispatch) => {

    try {

        dispatch(setLoading(true));


        const cleanParams =
            Object.fromEntries(
                Object.entries(params)
                    .filter(([_, value]) => value !== "")
            );


        const query =
            new URLSearchParams(cleanParams).toString();


        const response =
            await getMethod(`/products/admin/products/list?${query}`);


        if (response.success) {

            dispatch(
                setProducts({
                    products: response.products,
                    pagination: response.pagination
                })
            );

        }


    } catch (error) {

        console.error(error);

    } finally {

        dispatch(setLoading(false));

    }

};

export const fetchProductDetailsAction = (id) => async (dispatch) => {
    try {
        dispatch(setLoading(true));

        const response = await getMethod(`/products/${id}`);

        if (response.success) {
            dispatch(setSelectedProduct(response.product));
        }
    } catch (error) {
        console.error("Error fetching product details", error);
    } finally {
        dispatch(setLoading(false));
    }
};

export const createProductAction = (data) => async (dispatch) => {
    const response = await postMethod("/products", data);
    if (response.success) {
        dispatch(addProduct(response.product));
    }
    return response;
};

export const updateProductAction = (id, data) => async (dispatch) => {
    const response = await putMethod(`/products/${id}`, data);
    if (response.success) {
        dispatch(updateProduct(response.product));
    }
    return response;
};

export const deleteProductAction = (id) => async (dispatch) => {
    const response = await deleteMethod(`/products/${id}`);
    if (response.success) {
        dispatch(removeProduct(id));
    }
    return response;
};
